<template>
    <v-container>
        <v-combobox
            v-model="selectedUserWishPeriod"
            :items="wishPeriods"
            item-title="title"
            item-text="title"
            label="Wunschdienstperiode"
            clearable
            hide-selected
            return-object></v-combobox>
        <div v-if="selectedUserWishPeriod">
            <WorkViewUser :wish-period="selectedUserWishPeriod"
                        :user-data="user">
            </WorkViewUser>
        </div>
    </v-container>
</template>

<script lang="ts">
import WorkViewUser from "@/components/WorkViewUser.vue"
import {computed, onMounted, ref, watch} from 'vue'
import { useCollection, useFirestore } from 'vuefire'
import { collection, updateDoc, doc, Timestamp } from 'firebase/firestore'
import { GetUserDataEmplno } from '@/data/userData'
import { createDialog } from 'vuetify3-dialog'
import { notifySuccess } from 'vuetify3-dialog'
import {GetWishPeriodsData} from "@/data/wishPeriod"
import {useRouter} from "vue-router"
import {useStore} from "@/store"
import type { UserData, EmployServiceData, WishPeriod } from '@/types/firestore'

export default {
    components: { WorkViewUser },
    setup() {
        const db = useFirestore()
        const router = useRouter()
        const store = useStore()
        const emplno = store.getters.emplno
        const selectedUserWishPeriod = ref(null)
        const userWishesWithPeriods = ref([])
        const user = ref<UserData | undefined>({})
        const wishPeriods = ref<WishPeriod[] | undefined>([])

        const loadUserWishes = async () => {
            user.value = await GetUserDataEmplno(emplno)
            wishPeriods.value = await GetWishPeriodsData()
            
            userWishesWithPeriods.value = wishPeriods.value.map(wish => {
                return {
                    period: wish,
                }
            })
        }

        watch(() => router.currentRoute.value.params.userId, async () => {
            await loadUserWishes();
        })

        onMounted(async () => {
            await loadUserWishes();
        })

        return {
            selectedUserWishPeriod,
            userWishesWithPeriods,
            wishPeriods,
            user,
            loadUserWishes
        }
    }
}

</script>